import * as z from "zod"

export const BetterAuthJwksModel = z.object({
  id: z.string(),
  publicKey: z.string(),
  privateKey: z.string(),
  createdAt: z.date(),
  expiresAt: z.date().nullish(),
  alg: z.string().nullish(),
  crv: z.string().nullish(),
})
